// Function definitions
const search = function (params = {}) {
    return window.axios.get('/api/users', {
        params: params,
    });
};

const get = function (id) {
    return window.axios.get('/api/users/' + id);
};

const create = function (user) {
    return window.axios.post('/api/users', user);
};

const update = function (user) {
    return window.axios.put('/api/users/' + user.id, user);
};

const changePassword = function (user, passwords) {
    return window.axios.put('/api/users/' + user.id + '/change-password', passwords);
};

const deleteUser = function (user) {
    return window.axios.delete('/api/users/' + user.id, user);
};

const engineers = function () {
    return search({
        'filter[engineers]': true,
    })
};

const officeStaff = function () {
    return search({
        'filter[office]': true,
    })
};

const leaveAllowance = function (userId) {
    return window.axios.get(`/api/users/${userId}/leave-allowance`);
};

export default {
    search,
    get,
    create,
    update,
    changePassword,
    delete: deleteUser,
    engineers,
    officeStaff,
    leaveAllowance,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/UsersService.js